import { useNavigate } from "react-router-dom";
import { MenuItem } from "./MenuData";

// **Determine Selected Product Based on Route**
export const determineSelectedProduct = (pathname: string): string => {
  if (pathname.startsWith("/reflector-v2")) return "CTX Reflector V2";
  if (pathname.startsWith("/reflector")) return "CTX Reflector";
  if (pathname.startsWith("/ctxhub")) return "CTX Hub";
  if (pathname.startsWith("/kontrol")) return "Kontrol Edge";
  return "";
};

const routeAliasMap: Record<string, string> = {
  "/kontrol/port-details": "/kontrol/port",
  "/kontrol/datacenter-details": "/kontrol/datacenter",
  "/kontrol/internet/internet-details": "/kontrol/internet",
  "/kontrol/backbone-details": "/kontrol/backbone",
  // Add other detail routes as needed
};

// **Filter Service Items Based on Selected Product**
export const getFilteredServiceItems = (
  product: string,
  items: MenuItem[]
): MenuItem[] => {
  if (product === "Kontrol Edge") {
    return items.filter(
      (item) =>
        item.path?.startsWith("/kontrol") ||
        item.children?.some((child) => child.path?.startsWith("/kontrol"))
    );
  }
  if (product === "CTX Reflector") {
    const reflectorItem = items.find((item) => item.label === "CTX Reflector");
    // Si lo encuentra y tiene hijos, devolvemos SOLO los hijos, así se omite el padre.
    if (reflectorItem && reflectorItem.children) {
      return reflectorItem.children;
    }
    return [];
  }
  return [];
};

// **Handle Selection From Dropdown**
export const handleSelection = (
  selected: string,
  navigate: ReturnType<typeof useNavigate>,
  setSelectedProduct: React.Dispatch<React.SetStateAction<string>>
) => {
  setSelectedProduct(selected);
  if (selected === "Kontrol Edge") {
    navigate("/kontrol");
  } else if (selected === "CTX Reflector V2") {
    navigate("/reflector-v2/overview");
  } else if (selected === "CTX Reflector" || selected === "CTX Hub") {
    navigate("/");
  }
};

export const expandMatchingParents = (
  items: MenuItem[],
  path: string,
  setExpandedSections: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >,
  setActiveItem: React.Dispatch<React.SetStateAction<string>>
): boolean => {
  for (const item of items) {
    if (item.children) {
      const foundInChildren = expandMatchingParents(
        item.children,
        path,
        setExpandedSections,
        setActiveItem
      );

      if (foundInChildren) {
        // Expand the parent section
        setExpandedSections((prev) => ({ ...prev, [item.label]: true }));
        return true;
      }
    }

    if (item.path && isPathMatch(item.path, path)) {
      setActiveItem(item.label); // or item.id if that's what you're tracking
      return true;
    }
  }

  return false; // No match found at this level
};


export const findMenuItemByPath = (
  items: MenuItem[],
  path: string
): MenuItem | null => {
  for (const item of items) {
    if (item.path && isPathMatch(item.path, path)) return item;
    if (item.children) {
      const found = findMenuItemByPath(item.children, path);
      if (found) return found;
    }
  }
  return null;
};

const isPathMatch = (menuPath: string, currentPath: string): boolean => {
  const currentBase = currentPath.split("?")[0];  // Remove query params
  const menuBase = menuPath.split("?")[0];        // Normalize menuPath too

  // Direct match
  if (menuBase === currentBase) return true;

  // Handle aliases (e.g., port-details → port)
  const aliasTarget = routeAliasMap[currentBase];
  const matchResult = !!aliasTarget && aliasTarget === menuBase;
  
  return matchResult;
};





